import {
  MODAL_STORAGE_UPLOAD,
  MODAL_STORAGE_DELETE,
  MODAL_STORAGE_EDIT,
  MODAL_STORAGE_UPDATE,
  MODAL_CHANNEL_CREATE,
  MODAL_CHANNEL_EDIT,
  MODAL_STORAGE_DIRECTORY_CREATE,
  MODAL_STORAGE_DIRECTORY_SMART_CREATE,
  MODAL_STORAGE_DIRECTORY_EDIT,
  MODAL_STORAGE_DIRECTORY_SMART_EDIT,
  MODAL_STORAGE_DELETE_LINKS,
  MODAL_USER_DELETE,
  MODAL_USER_CREATE,
  MODAL_USER_EDIT,
  MODAL_GROUP_CREATE,
  MODAL_GROUP_DELETE,
  MODAL_GROUP_EDIT,
  MODAL_TAGS
} from '../types'

const initialState = {
  storageUploadModal: false,

  storageDeleteModal: false,

  storageEditModal: {
    status: false,
    asset: {
      guid: null,
      properties: {
        shareable: false,
        downloadable: false,
        timestampAccessStart: null,
        timestampAccessEnd: null
      },
      tags: []
    }
  },

  storageUpdateModal: false,

  channelCreateModal: false,

  channelEditModal: false,

  channelDirectoryCreateModal: {
    status: false,
    id: null
  },

  channelDirectoryEditModal: {
    status: false,
    id: null,
    name: null
  },

  storageDeleteLinksModal: {
    status: false,
    id: null,
    list: []
  },

  userDeleteModal: false,

  userCreateModal: false,

  userEditModal: {
    status: false,
    user: {}
  },

  groupCreateModal: false,
  groupDeleteModal: {
    status: false,
    id: null
  },

  groupEditModal: {
    status: false,
    name: null,
    id: null
  },

  tagsModal: {
    status: false
  },

  channelDirectorySmartCreateModal: {
    status: false,
    id: null
  },

  channelDirectorySmartEditModal: {
    status: false,
    id: null
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case MODAL_STORAGE_UPLOAD:
      return {
        ...state,
        storageUploadModal: action.payload
      }

    case MODAL_STORAGE_DELETE:
      return {
        ...state,
        storageDeleteModal: action.payload
      }

    case MODAL_STORAGE_EDIT:
      return {
        ...state,
        storageEditModal: action.payload.status === true ? action.payload : initialState.storageEditModal
      }

    case MODAL_STORAGE_UPDATE:
      return {
        ...state,
        storageUpdateModal: action.payload
      }

    case MODAL_CHANNEL_CREATE:
      return {
        ...state,
        channelCreateModal: action.payload
      }

    case MODAL_CHANNEL_EDIT:
      return {
        ...state,
        channelEditModal: action.payload
      }

    case MODAL_STORAGE_DIRECTORY_CREATE:
      return {
        ...state,
        channelDirectoryCreateModal: action.payload
      }

    case MODAL_STORAGE_DIRECTORY_SMART_CREATE:
      return {
        ...state,
        channelDirectorySmartCreateModal: action.payload
      }

    case MODAL_STORAGE_DIRECTORY_EDIT:
      return {
        ...state,
        channelDirectoryEditModal: action.payload
      }

    case MODAL_STORAGE_DIRECTORY_SMART_EDIT:
      return {
        ...state,
        channelDirectorySmartEditModal: action.payload
      }

    case MODAL_STORAGE_DELETE_LINKS:
      return {
        ...state,
        storageDeleteLinksModal: action.payload
      }

    case MODAL_USER_DELETE:
      return {
        ...state,
        userDeleteModal: action.payload
      }

    case MODAL_USER_CREATE:
      return {
        ...state,
        userCreateModal: action.payload
      }

    case MODAL_USER_EDIT:
      return {
        ...state,
        userEditModal: action.payload
      }

    case MODAL_GROUP_CREATE:
      return {
        ...state,
        groupCreateModal: action.payload
      }

    case MODAL_GROUP_DELETE:
      return {
        ...state,
        groupDeleteModal: action.payload
      }

    case MODAL_GROUP_EDIT:
      return {
        ...state,
        groupEditModal: action.payload
      }

    case MODAL_TAGS:
      return {
        ...state,
        tagsModal: action.payload
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/modal.js